import { render } from "./ReportTabs.vue?vue&type=template&id=473904a8&scoped=true"
import script from "./ReportTabs.vue?vue&type=script&lang=js"
export * from "./ReportTabs.vue?vue&type=script&lang=js"

import "./ReportTabs.vue?vue&type=style&index=0&id=473904a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-473904a8"]])

export default __exports__